import { QueryCellInfoEventArgs, RowDataBoundEventArgs } from '@syncfusion/ej2-react-grids';

export interface RowStylingRule {
    condition: (data: any) => boolean;
    style: {
        light: string;
        dark: string;
    };
}

export const applyRowStyling = (
    args: RowDataBoundEventArgs,
    rules: RowStylingRule[],
    theme: 'light' | 'dark' = 'light'
): void => {
    if (!args.data || !args.row) return;

    const data = args.data as any;

    for (const rule of rules) {
        if (rule.condition(data)) {
            const row = args.row as HTMLElement;
            const styleString = rule.style[theme];
            const styles = styleString.split(';');
            styles.forEach(s => {
                const [prop, val] = s.split(':');
                if (prop && val) {
                    const cleanProp = prop.trim();
                    const cleanVal = val.replace('!important', '').trim();
                    (row.style as any)[cleanProp] = cleanVal;
                }
            });
            row.classList.add('custom-row-styled');
        }
    }
};

export const booleanGrayRule = (field: string, expectedValue = true): RowStylingRule => ({
    condition: (data) => {
        const value = data[field] ?? data.taskData?.[field];
        return value === expectedValue;
    },
    style: {
        light: 'background-color: #d8dde5 !important; color: #6c737d !important',
        dark:  'background-color: #3c4756 !important; color: #a4acb8 !important',
    },
});

/* export const rowGrayRule = (priorityCode: string): RowStylingRule => ({
    condition: (data) => {
        const code = data.priority_code ?? data.taskData?.priority_code;
        //console.log('rowGrayRule check:', code, '===', priorityCode, '->', code?.trim() === priorityCode);
        return code?.trim() === priorityCode;
    },
    style: {
        light: 'background-color: #d8dde5 !important; color: #6c737d !important',
        dark:  'background-color: #3c4756 !important; color: #a4acb8 !important',
    },
}); */
